import { render, staticRenderFns } from "./requestSpareParts.vue?vue&type=template&id=bd5e3604&scoped=true&"
import script from "./requestSpareParts.vue?vue&type=script&lang=js&"
export * from "./requestSpareParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5e3604",
  null
  
)

export default component.exports